import * as React from "react";
import Modal from "@mui/material/Modal";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Form, Formik } from "formik";
import theme from "../../../theme";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { StyledBox, StyledBoxFlex } from "../success-virtual-locker/style";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import CustomInput from "../../common/input/CustomInput";
import CustomDropdown from "../../common/common-dropdown/CustomDropdown";
import { lockerOptionDropdown, lockerStatusOptionDropdown } from "../product-details/constant";
import { StyledBoxCard } from "../setting-coupon/style";
import { StyledTypography } from "../manual-split-calculation/style";
import { SETTING_LOCKER_ADD, SETTING_LOCKER_EDIT, SETTING_LOCKER_LIST, } from "../../../actions/admin/customer-actions";

// Yup Validation Schema
const validationSchema = Yup.object({

  // name: Yup.string()
  //   .trim()
  //   .required("name is required")
  //   .min(2, "name must be at least 2 characters")
  //   .max(50, "name must be at most 50 characters"),

  // type: Yup.string()
  //   .required("Type to is required"),

  // countries: Yup.string()
  //   .required("Countries from is required"),

  // status: Yup.string()
  //   .required("Status is required"),

});

export default function SettingLocker({ open, handleClose, isEditMode, editRecord }) {
  const dispatch = useDispatch();
  const [initialValue, setInitialValue] = React.useState({
    name: "",
    type: "",
    status: "",
    countries: "",
    terms: "",
    // last_updatedAt: "",
  })

  const getRecordList = React.useCallback(
    (values) => {
      dispatch({
        type: SETTING_LOCKER_LIST,
        payload: values,
      });
    },
    [dispatch]
  );
  React.useEffect(() => {
    if (isEditMode) {
      setInitialValue({
        name: editRecord?.name || "",
        type: editRecord?.type || "",
        status: editRecord?.status || "",
        // last_updatedAt: editRecord?.lastDate
        //   ? moment(editRecord?.lastDate)?.format("DD MMM YYYY")
        //   : "-",
        countries: editRecord?.countries || "",
        terms: editRecord?.terms || "",
      })
    }
  }, [isEditMode, editRecord])
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <StyledTypography>Create Locker Terms</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            if (isEditMode && editRecord.id) {
              dispatch({
                type: SETTING_LOCKER_EDIT,
                payload: {
                  ...values,
                  id: editRecord.id,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            } else {
              dispatch({
                type: SETTING_LOCKER_ADD,
                payload: {
                  ...values,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            }
          }}
        >
          {({ values, errors, touched, setFieldValue, handleChange, handleBlur }) => (
            <Form>
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  {/* name */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      // required
                      placeholder="name"
                      customLabel="Name"
                      name={`name`}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.name &&
                        Boolean(errors.name)
                      }
                      helperText={
                        touched.name &&
                        errors.name
                      }
                    />
                  </Grid>

                  {/* type */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={lockerOptionDropdown}
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      // required
                      customLabel="Type"
                      name={`type`}
                      value={values.type}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={
                        touched.type &&
                        Boolean(errors.type)
                      }
                      helperText={
                        touched.type &&
                        errors.type
                      }
                    />
                  </Grid>
                  {/* countries */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      // required
                      placeholder="countries"
                      customLabel="countries"
                      name={`countries`}
                      value={values?.countries}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.countries &&
                        Boolean(errors.countries)
                      }
                      helperText={
                        touched.countries &&
                        errors.countries
                      }
                    />
                  </Grid>

                  {/* Status */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={lockerStatusOptionDropdown}
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      // required
                      customLabel="Status"
                      name={`status`}
                      value={values?.status}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={
                        touched.status &&
                        Boolean(errors.status)
                      }
                      helperText={
                        touched.status &&
                        errors.status
                      }
                    />
                  </Grid>
                  {/* content */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="150px"
                      // required
                      // type="date"
                      placeholder="Edit Terms"
                      customLabel="Edit Terms"
                      name={`terms`}
                      value={values?.terms}
                      onChange={handleChange}
                      onBlur={handleBlur}
                       multiline
                      rows={6} 
                      textAlign={{
                        textAlign: "left",
                        "& .MuiInputBase-input": {
                          textAlign: "left",
                          verticalAlign: "top",
                        },
                      }}
                      error={
                        touched.terms &&
                        Boolean(errors.terms)
                      }
                      helperText={
                        touched.terms &&
                        errors.terms
                      }
                    />
                  </Grid>
                  {/* Submit */}
                  <Grid container justifyContent="space-between" width="100%">
                    <Grid item>
                      <Button variant="outlined" onClick={()=>handleClose}>
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>

                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledBox>
    </Modal>
  );
}
